import React from 'react'
import { connect } from 'react-redux'
import { doGetNumberRuleList } from '../../reducers/actions'
import ContractNumberRuleDiv from './ContractNumberRuleDiv'
class ContractNumberRuleList extends React.Component {
  state = {}
  componentDidMount = () => {
    this.handleInitContractNumberRule()
  }
  handleInitContractNumberRule = () => {
    const { onSave, onClose, dispatch } = this.props
    dispatch(doGetNumberRuleList({
      name: '合同自动编号设置',
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ initValues基本信息 })
        }
      }
    }))
  }
  handleAddContractNumberRule = (data) => {
    Tyan.pubForm.showDialog('合同自动编号规则设置', props => <ContractNumberRuleDiv {...props} id={-1} onSave={this.handleInitContractNumberRule} />)
    this.setState({})
  }

  handleEditContractNumberRule = (data) => {
    Tyan.pubForm.showDialog('合同自动编号规则设置', props => <ContractNumberRuleDiv {...props} id={data.id} onSave={this.handleInitContractNumberRule} />)
    this.setState({})
  }

  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  fieldset模板 = () => {
    return [{
      _grid: '', name: '模板', rowNumbers: true, minRows: 5,
      columns: [
        { _text: '名称', minWidth: 300, flex: 1 },
        { _text: '条件表达式', minWidth: 300, flex: 1 },
        { _text: '序号', minWidth: 300, flex: 1 },
      ],
      onDoubleTap: this.handleEditContractNumberRule,
    }]
  }

  render = () => {
    const { showBody: Body } = this.props

    return <Body data={this} maxWidth={1200}
      controls={
        [
          { _button: '添加', handler: this.handleAddContractNumberRule },
          { _button: '关闭', handler: this.handlerClose },
        ]}
      fieldsets={[
        { title: '', name: '基本信息', _fieldset: this.fieldset模板(), /* docked: 'top',  */flex: 1 },
      ]}
    />
  }
}

export default connect()(ContractNumberRuleList)